type Props = {
  password: string;
};

function scorePassword(password: string): { score: number; label: string; color: string } {
  if (!password) return { score: 0, label: 'Enter a password', color: 'bg-slate-200' };
  let score = 0;
  if (password.length >= 12) score += 1;
  if (password.length >= 16) score += 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;
  if (score <= 2) return { score, label: 'Weak', color: 'bg-red-500' };
  if (score <= 3) return { score, label: 'Fair', color: 'bg-amber-500' };
  if (score <= 4) return { score, label: 'Good', color: 'bg-lime-500' };
  return { score, label: 'Strong', color: 'bg-emerald-500' };
}

export function PasswordStrengthMeter({ password }: Props) {
  const { score, label, color } = scorePassword(password);
  const width = Math.min(100, Math.max(8, (score / 5) * 100));
  return (
    <div className="mt-2" aria-live="polite">
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200">
        <div className={`h-full transition-all ${color}`} style={{ width: `${width}%` }} />
      </div>
      <p className="mt-1 text-xs text-slate-500">Strength: {label}</p>
    </div>
  );
}
